<template>
  <div id="app">
    <Navbar :user="user" />
    <router-view :key="$route.path" />
    <Footer :user="user" />
  </div>
</template>

<script>
import Navbar from './components/NavbarHeader';
import Footer from './components/NavbarFooter';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: { Footer, Navbar },
  computed: {
    ...mapGetters({ user: 'auth/user' }),
  },
};
</script>

<style>
#app {
  overflow-y: hidden;
}
/* source: https://github.com/twbs/bootstrap/issues/16088#issuecomment-125687647 */
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
</style>
